<template>
	<div>
		<h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Menu Items Category {{ (menu_items_category.name) ? (" - " + menu_items_category.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Menu Items Category - {{ menu_items_category.name }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Menu Items Category - {{ menu_items_category.name }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="menu_items_category.code" input-classes="form-control"/>
                <base-input alternative="" label="Name" placeholder="" v-model="menu_items_category.name" input-classes="form-control" required/>
            </div>

            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>

                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
	</div>
</template>

<script>
	import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    var component_x;

    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },

        mounted: async function () {
            const systemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Menu Items Category?field_name=name', null)
            const systemModuleId = systemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + systemModuleId + '?field_name=system_module_id', null)

            if (this.serverType == 'branch' || this.$attrs.viewMode == true) {
                var form = document.getElementById("form-proper");
                var elements = form.elements;

                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }

            component_x = this

            if (component_x.profileId > 0) {
                let menu_item_category_data = await HTTPRequest.getRequest(component_x.endPoint + 'menu_items_categories/' + component_x.profileId, null, "BXI-File")
                if (menu_item_category_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (menu_item_category_data["error"] == undefined) {
                        component_x.menu_items_category = menu_item_category_data
                        component_x.inputName = menu_item_category_data["name"]
                        component_x.inputCode = menu_item_category_data["code"]
                    } else {
                        this.errors = menu_item_category_data["error"].split(",")
                    }
                }
            }
        },

        data: function () {
            return {
                menu_items_category: {},
                errors: [],

                customFormMode: 1,
                // customForm: {},
                profileData: {},
                // dynamicFormKey: 0,
                formErrors: []
            }
        },

        methods: {
            validateForm() {
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.menu_items_category.code, 0, 10));
                this.errors.push(ValidateField.required('Name', this.menu_items_category.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.menu_items_category.name, 0, 30));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },

            create: async function () {
                if (!this.validateForm()) {
                    this.menu_items_category.code = this.menu_items_category.code.trim()
                    this.menu_items_category.name = this.menu_items_category.name.trim()
                    this.menu_items_category.status = 'A'

                    var menu_items_category_payload = { menu_items_category: this.menu_items_category }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'menu_items_categories', null, menu_items_category_payload, "BXI-File")
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },

            update: async function () {
                if (!this.validateForm()) {
                    this.menu_items_category.code = this.menu_items_category.code.trim()
                    this.menu_items_category.name = this.menu_items_category.name.trim()
                    let status = (this.menu_items_category.status == null) ? "A" : this.menu_items_category.status
                    this.menu_items_category.status = status

                    var menu_items_category_payload = { menu_items_category: this.menu_items_category }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'menu_items_categories/' + this.profileId, null, menu_items_category_payload, "BXI-File")
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },

         
        }
    }
</script>